function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import { safeSelect, updateState } from '@sie/web-common-utils';
import PropTypes from 'prop-types';
import { classNamesFor } from '../utils/classNames';
import loadSvg from './loadSvgBrowser';
/**
 * The StylableSvg component represents all icons used throughout the UI and represents a
 * true UI primitive. StylableSvgs are asynchronously loaded from static.playstation.com by default
 * but is configurable
 *
 * ## Configuration
 *
 * ## Browser usage
 *
 * ```javascript
 * StylableSvg.configure({
 *    npEnvironment: 'e1-np',
 *    url: {
 *      'ps-icon': 'https://static.{envExceptNp}.playstation.com/icons/0.9.0/'
 *      'ps-brand-text': 'https://static.{envExceptNp}.playstation.com/images/0.6.0/vector/text/'
 *      'ps-illustration': 'https://static.{envExceptNp}.playstation.com/images/0.6.0/vector/illustrations/'
 *    }
 * })
 * ```
 *
 * ### SSR
 *
 * The default SSR support is basic and will not result in svg icons being displayable
 * immediately upon browser rendering the SSR'd page. To configure basic SSR usage in your
 * SSR entrypoint configure the StylableSvg compoonent with:
 *
 * ```javascript
 * StylableSvg.configure({
 *    isSsr: true
 * })
 * ```
 * To get SVG icons to display after SSR you must use the loadSvgSsr strategy. See section below
 *
 * #### Custom loader
 *
 * ```javascript
 * import { loadSvgSsr } from '@sie/web-common-react-components/server';
 *
 * // strategy for loading svg symbols server side leveraging webpack raw-loader
 * StylableSvg.load = loadSvgSsr(({ namespace, type }) => {
 *   if (namespace === 'ps-icon') return require(`@sie/web-common-icons/dist/${type}.svg`);
 *
 *   return '';
 * });
 * ```
 *
 * ## Usage
 *
 * ```jsx
 * <StylableSvg
 *   className="psw-h1 psw-c-accent-1"
 *   namespace="ps-brand-text"
 *   type="playstation-store"
 * />
 * ```
 *
 * ## Props
 */

var StylableSvg = /*#__PURE__*/function (_PureComponent) {
  _inherits(StylableSvg, _PureComponent);

  var _super = _createSuper(StylableSvg);

  function StylableSvg() {
    var _this;

    _classCallCheck(this, StylableSvg);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      viewBox: null
    });

    return _this;
  }

  _createClass(StylableSvg, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          qa = _this$props.qa,
          className = _this$props.className,
          type = _this$props.type,
          label = _this$props.label,
          namespace = _this$props.namespace;
      var viewBox = this.state.viewBox;

      var _StylableSvg$getClass = StylableSvg.getClassName({
        className: className,
        type: type,
        namespace: namespace
      }),
          root = _StylableSvg$getClass.root;

      var config = StylableSvg.config;
      var svg = StylableSvg.load(type, {
        namespace: namespace,
        label: label,
        viewBox: viewBox,
        config: _objectSpread(_objectSpread({}, config), {}, {
          url: safeSelect(config, "url.".concat(namespace)) || config.url
        }),
        onLoad: function onLoad(_ref) {
          var settledViewBox = _ref.viewBox;
          return _this2.setState({
            viewBox: settledViewBox
          });
        }
      });
      return /*#__PURE__*/React.createElement("span", {
        "data-qa": qa,
        className: root
      }, svg);
    }
  }]);

  return StylableSvg;
}(PureComponent);

var cx = classNamesFor(StylableSvg);
/**
 * StylableSvg loading strategy. The default is set up to asynchronously load icons from static.
 * playstation.com. To load icons from disk use loadSvgSsr or you can override this function
 * to implement your own strategy.
 *
 * @param {string} type the type of icon to load (e.g. ps-store)
 * @param {Object} options
 * @param {string} [options.label] the title text to use for the icon
 * @param {Object} options.config the StylableSvg configuration
 * @returns {ReactNode} the async icon markup
 */

StylableSvg.load = loadSvg;

StylableSvg.resetPalette = function () {
  var resetPalette = safeSelect(StylableSvg, 'load.reset');

  if (typeof resetPalette === 'function') {
    resetPalette();
  }
};
/**
 * Gets the classNames attached to the style hooks for this component.
 * @returns {string} the aliased classNames for StylableSvg
 */


StylableSvg.getClassName = function (_ref2) {
  var className = _ref2.className,
      namespace = _ref2.namespace,
      type = _ref2.type;
  var classNameBase = namespace.replace(/^ps-/, 'psw-');
  return {
    root: cx(classNameBase, _defineProperty({}, "".concat(classNameBase, "--").concat(type), type), className)
  };
};
/**
 * Defines aliases for classNames used by this component
 */


StylableSvg.useClassNames = function (classNames) {
  StylableSvg.classNames = classNames;
};

var staticOriginTemplate = 'https://static.{envExceptNp}.playstation.com';
var staticVectorImagesTemplate = "".concat(staticOriginTemplate, "/images/v0/vector");
StylableSvg.config = {
  npEnvironment: 'e1-np',
  url: {
    'ps-icon': "".concat(staticOriginTemplate, "/icons/v0/"),
    'ps-brand-text': "".concat(staticVectorImagesTemplate, "/text/"),
    'ps-illustration': "".concat(staticVectorImagesTemplate, "/illustrations/")
  },
  isSsr: (typeof document === "undefined" ? "undefined" : _typeof(document)) !== 'object'
};

StylableSvg.configure = function () {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  StylableSvg.config = updateState(StylableSvg.config, config);
};

StylableSvg.defaultProps = {
  qa: '',
  className: '',
  namespace: 'ps-icon',
  label: ''
};
StylableSvg.propTypes = {
  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * What type of svg use case (ps-icon, ps-brand-text, ps-illustration)
   */
  namespace: PropTypes.string,

  /**
   * Which icon to load (see ui sandbox for assortment)
   */
  type: PropTypes.string.isRequired,

  /**
   * Give the icon a label for screen readers to read
   */
  label: PropTypes.string
};
export default StylableSvg;